<template>
  <div class="px-4">
    <TableItem v-for="item in items" :key="item.id" :item="item" :access_type="user_access_type" />
  </div>
</template>

<script>
import TableItem from './TableItem.vue'
export default {
  components: {
    TableItem
  },
  data() {
    return {
      items: [],
      user_access_type: "",
      manual_grading_data: [],
    };
  },
  methods: {
    fetchData() {
      this.$store.dispatch('exam/all')
        .then(res => {
          let data = res.data
          this.items = [
            ...data.data
          ]
          this.user_access_type = data.access_type
          console.log('Fetched data:', data);
          console.log('User access type:', this.user_access_type);
        })
      .catch(err => {
        console.error('Error creating exam:', err);
      });
    },
    fetchApplicantExam() {
      this.$store.dispatch('exam/getApplicantExams')
        .then(res => {
          let data = res.data
          this.items = [
            ...data.data
          ]
          this.user_access_type = data.access_type
        })
    },
    fetchManualGradingExamData() {
      this.$store.dispatch('exam/getManualGrading')
        .then(res => {
          let data = res.data
          this.manual_grading_data = [
            ...data.data
          ]
          this.user_access_type = data.access_type
        })
    },
  },
  created() {
    if(this.role_modules.some(item => item.value == 'exam.create')){
      this.fetchData()
      this.fetchManualGradingExamData()
    }
    else
      this.fetchApplicantExam()
  },
};
</script>
